import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { cloneData } from 'src/app/helper/class/utilityHelper';
import { User } from 'src/app/helper/interface/user';
import { AuthService } from 'src/app/helper/service/auth.service';
import { MasterApiService } from 'src/app/modules/master/service/master-api.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat-ai.component.html',
  styleUrls: ['./chat-ai.component.scss'],
})
export class ChatAiComponent {
  messages: {
    role: 'user' | 'assistant' | 'system';
    content: string;
    editing?: boolean;
    tempContent?: string;
  }[] = [];
  title = 'Ai Chat Assistant';
  userInput = '';
  isLoading = false;
  user: User = {} as User;

  constructor(
    private masterApi: MasterApiService,
    private auth: AuthService,
    private _bsModalRef: BsModalRef
  ) {
    // Add system message (first load only)
    this.messages.push({
      role: 'system',
      content: '👋 Good Morning Vinoth! What would you like to do today?',
    });
    this.user = this.auth.currentUserValue;
  }

  async sendMessage() {
    if (!this.userInput.trim() || this.isLoading) return;

    // Push user message
    this.messages.push({ role: 'user', content: this.userInput });

    const payload = { messages: cloneData(this.messages) };

    const lastIndex =
      this.messages.push({ role: 'assistant', content: '' }) - 1;

    this.isLoading = true;
    this.userInput = '';

    this.masterApi.getChatAiStream(
      payload,
      (char: string) => {
        this.messages[lastIndex].content += char;
      },
      () => {
        this.isLoading = false;
      }
    );
  }

  copyMessage(msg: string) {
    navigator.clipboard.writeText(msg);
  }

  toggleEdit(msg: any) {
    msg.tempContent = msg.content; // backup
    msg.editing = true;
  }

  saveEdit(msg: any) {
    msg.content = msg.tempContent;
    msg.editing = false;
  }

  cancelEdit(msg: any) {
    msg.editing = false;
  }
  close() {
    this._bsModalRef?.hide();
  }
}
